import useAjax from "@hooks/use-ajax.hook";
import dayjs from "dayjs";
import { useCallback } from "react";

export type SettingsType = {
  price: number;
  sale: number | null;
  disabled: boolean;
  boatId: number;
  date: Date;
};

const useAddSettings = () => {
  const { request, error, loading, clearError } = useAjax();

  const addSettings = useCallback(
    (settings: SettingsType) =>
      request<number>("add_setting", {
        ...settings,
        date: dayjs(settings.date).format("YYYY-MM-DD"),
      }),
    [request]
  );

  return { addSettings, loading, error, clearError };
};

export default useAddSettings;
